import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {GlobalDataService} from '../global-data.service';
import {AuthenticationService} from '../authentication-service.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate()
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError() {
    this.globalDataService.token = null;
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts